// The Edmentum levelling scale. Shared between the SPA and the Worker so the
// allowed values are defined in exactly one place.
export const LEVELS = ['T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'] as const;
export type Level = (typeof LEVELS)[number];

export const SCOPES = ['in_role', 'stretch'] as const;
export type Scope = (typeof SCOPES)[number];

export const STATUSES = ['draft', 'confirmed'] as const;
export type Status = (typeof STATUSES)[number];

export const DIMENSION_CATEGORIES = ['scope_accountability', 'behaviours_actions'] as const;
export type DimensionCategory = (typeof DIMENSION_CATEGORIES)[number];

export const EVIDENCE_KINDS = ['pr', 'ticket', 'doc', 'metric', 'slack', 'link', 'screenshot'] as const;
export type EvidenceKind = (typeof EVIDENCE_KINDS)[number];

// Numeric rank of a level: T1 -> 1 ... T7 -> 7. Used for gap deltas and the
// matrix's "steps above assigned" weighting.
export function levelRank(level: Level): number {
  return LEVELS.indexOf(level) + 1;
}
